$(document).ready(function () {
    $('.navbar-toggler').click(function () {
        $('.navbar-collapse').toggleClass('show');
        $('.mobile-header').toggleClass('active');
    })
})

